"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var index_1 = require("../enhancers/index");

var split_props_1 = __importDefault(require("./split-props"));
/**
 * Convenience method to split the Box props.
 *
 * Useful for when you want to pass all of the Box props to the root Box and
 * pass the remaining props to a child element (e.g: disabled, readOnly, required, etc).
 */


function splitBoxProps(props) {
  return split_props_1.default(props, index_1.propNames);
}

exports.default = splitBoxProps;